<div class="chat-app" :class="{ 'mobile-chat-active': active_conversation_id }">
  <Navbar />

  <div class="page-wrapper chat-page-wrapper d-flex flex-grow-1 overflow-hidden">
    <Sidebar />

    <div class="hero-section w-100 chat-section d-flex flex-grow-1 overflow-hidden">
      <div class="chat-container chat-viewport-container p-0 w-100 d-flex flex-grow-1 overflow-hidden">
        <div class="oc-command-bar d-flex align-items-center flex-shrink-0">
          <div class="oc-command-search d-flex align-items-center flex-grow-1">
            <i class="fas fa-search"></i>
            <input type="text" placeholder="Search chats, files, and members" v-model="search_query">
          </div>
        </div>

        <div class="row g-0 flex-nowrap">

          <div
            class="col-12 col-lg-4 col-xl-3 conversations-sidebar d-flex flex-column overflow-hidden position-relative"
            :class="{ 'd-none d-lg-flex': active_conversation_id }"
          >
            <div class="sidebar-header-chat d-flex align-items-center justify-content-between flex-shrink-0">
              <h5 class="sidebar-title fw-bold mb-0">Chats</h5>
              <div class="d-flex align-items-center gap-2">
                <button class="oc-icon-btn d-none" title="More options"><i class="fas fa-ellipsis-v"></i></button>
                <button class="oc-icon-btn accent" title="New Chat" data-bs-toggle="modal" data-bs-target="#newConversationModal">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>

            <div class="sidebar-search flex-shrink-0 d-none">
              <div class="oc-search-wrap d-flex align-items-center gap-2">
                <i class="fas fa-search"></i>
                <input type="text" placeholder="Search chats" v-model="search_query">
              </div>
            </div>

            <div class="conversation-filters d-flex align-items-center flex-shrink-0" role="tablist" aria-label="Conversation filters">
              <button
                class="conversation-filter-btn"
                :class="{ active: conversation_filter === 'all' }"
                @click="conversation_filter = 'all'"
              >
                All <b v-if="conversation_filter_unread_counts.all">{{ conversation_filter_unread_counts.all }}</b>
              </button>
              <button
                class="conversation-filter-btn"
                :class="{ active: conversation_filter === 'chats' }"
                @click="conversation_filter = 'chats'"
              >
                Chats <b v-if="conversation_filter_unread_counts.chats">{{ conversation_filter_unread_counts.chats }}</b>
              </button>
              <button
                class="conversation-filter-btn"
                :class="{ active: conversation_filter === 'spaces' }"
                @click="conversation_filter = 'spaces'"
              >
                Spaces <b v-if="conversation_filter_unread_counts.spaces">{{ conversation_filter_unread_counts.spaces }}</b>
              </button>
            </div>

            <div v-if="portal_syncing" class="portal-sync-note d-flex align-items-center gap-2 flex-shrink-0 d-none">
              <span class="spinner-border spinner-border-sm"></span>
              <span>Syncing IC Workbook portals...</span>
            </div>

            <div class="conversations-list flex-grow-1 overflow-y-auto">
              <div v-if="!conversations_loaded" class="oc-loading d-flex flex-column align-items-center justify-content-center">
                <div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>
                <p>Loading chats…</p>
              </div>

              <div v-else-if="!conversations.length" class="sidebar-empty d-flex flex-column align-items-center justify-content-center text-center">
                <i class="fas fa-comments fa-3x"></i>
                <h6>No conversations yet</h6>
                <p>Start chatting with your colleagues</p>
                <button class="btn-oc-start" data-bs-toggle="modal" data-bs-target="#newConversationModal">
                  <i class="fas fa-plus me-1"></i>Start a chat
                </button>
              </div>

              <div v-else-if="filtered_conversations.length === 0" class="sidebar-empty d-flex flex-column align-items-center justify-content-center text-center">
                <i class="fas fa-search fa-3x"></i>
                <h6>No results</h6>
                <p>Try a different search term</p>
              </div>

              <div v-else>
                <a
                  v-for="conv in filtered_conversations" :key="conv.id"
                  href="#" class="conversation-item d-flex align-items-center"
                  :class="{ active: conv.id === active_conversation_id, unread: conv.unread_count > 0 }"
                  @click.prevent="select_conversation(conv.id)"
                >
                  <span v-if="conv.unread_count > 0" class="conv-unread-dot"></span>
                  <div
                    class="oc-avatar oc-avatar-md"
                    :class="[get_avatar_class(get_conversation_name(conv)), { 'oc-avatar-group': is_group_conversation(conv) }]"
                  >
                    <i v-if="is_group_conversation(conv)" class="fas fa-users"></i>
                    <span v-else>{{ get_initials(get_conversation_name(conv)) }}</span>
                  </div>
                  <div class="conv-body flex-grow-1 text-start">
                    <div class="d-flex align-items-center gap-2 min-w-0">
                      <div class="conv-name text-truncate" :class="{ unread: conv.unread_count > 0 }">
                        <i v-if="conv.is_pinned" class="fas fa-thumbtack conv-pinned-icon"></i>
                        {{ get_conversation_name(conv) }}
                      </div>
                    </div>
                    <div class="conv-preview text-truncate" :class="{ unread: conv.unread_count > 0 }">
                      {{ get_conversation_subtitle(conv) }}
                    </div>
                  </div>
                  <button
                    type="button"
                    class="conv-menu-trigger d-inline-flex align-items-center justify-content-center flex-shrink-0"
                    :class="{ open: active_conversation_menu_id === conv.id }"
                    title="Chat options"
                    @click.stop.prevent="toggle_conversation_menu(conv.id)"
                  >
                    <i class="fas fa-ellipsis-vertical"></i>
                  </button>
                  <div class="conv-meta d-flex flex-column align-items-end flex-shrink-0">
                    <span class="conv-time text-nowrap" :class="{ unread: conv.unread_count > 0 }">
                      {{ format_time_ago(conv.updated_at) }}
                    </span>
                    <span v-if="conv.unread_count > 0" class="conv-badge">
                      {{ conv.unread_count > 99 ? '99+' : conv.unread_count }}
                    </span>
                  </div>

                  <div v-if="active_conversation_menu_id === conv.id" class="conv-menu" @click.stop>
                    <button type="button" class="d-flex align-items-center gap-2 text-start" @click.stop.prevent="mark_conversation_read(conv)">
                      <i class="fas fa-check"></i>
                      <span>Mark read</span>
                    </button>
                    <button type="button" class="d-flex align-items-center gap-2 text-start" @click.stop.prevent="confirm_conversation_action(conv, 'clear')">
                      <i class="fas fa-eraser"></i>
                      <span>Clear conversation</span>
                    </button>
                    <button type="button" class="danger d-flex align-items-center gap-2 text-start" @click.stop.prevent="confirm_conversation_action(conv, 'delete')">
                      <i class="fas fa-trash"></i>
                      <span>Delete conversation</span>
                    </button>
                  </div>
                </a>
              </div>

            </div>
          </div>

          <section
            class="col-12 col-lg-8 col-xl-9 chat-panel d-flex flex-column"
            :class="{
              'd-none d-lg-flex': !active_conversation_id,
              'info-panel-open': show_info_panel
            }"
          >

            <div v-if="!active_conversation_id" class="chat-welcome d-flex align-items-center justify-content-center h-100">
              <div class="chat-empty-state text-center">
                <div class="chat-empty-illustration" aria-hidden="true">
                  <div class="empty-thread-card empty-thread-card-back">
                    <span></span>
                    <span></span>
                  </div>
                  <div class="empty-thread-card empty-thread-card-front">
                    <i class="fas fa-comment-dots"></i>
                    <span></span>
                    <span></span>
                  </div>
                  <div class="empty-hand empty-hand-left"></div>
                  <div class="empty-hand empty-hand-right"></div>
                  <div class="empty-orbit empty-orbit-red"><i class="fas fa-at"></i></div>
                  <div class="empty-orbit empty-orbit-gold"><i class="fas fa-list"></i></div>
                </div>
                <h3>No conversation selected</h3>
                <p>Choose a chat from the list to view messages, manage members, and see shared files.</p>
                <div class="chat-empty-hints d-flex align-items-center justify-content-center gap-2">
                  <span><i class="fas fa-search"></i>Search chats above</span>
                  <span><i class="fas fa-users"></i>Open a group to manage members</span>
                </div>
              </div>
            </div>

            <template v-else>

              <div class="chat-header d-flex align-items-center flex-shrink-0">
                <button class="oc-back-btn d-lg-none" @click="active_conversation_id = null" aria-label="Back">
                  <i class="fas fa-arrow-left"></i>
                </button>
                <div
                  class="oc-avatar oc-avatar-lg"
                  :class="[get_avatar_class(get_conversation_name(active_conversation)), { 'oc-avatar-group': active_is_group }]"
                >
                  <i v-if="active_is_group" class="fas fa-layer-group"></i>
                  <span v-else>{{ get_initials(get_conversation_name(active_conversation)) }}</span>
                </div>
                <div class="chat-header-info flex-grow-1 text-start ms-2">
                  <div class="d-flex align-items-center gap-2 min-w-0">
                    <span class="chat-header-name fw-bold d-block text-truncate">
                      {{ get_conversation_name(active_conversation) }}
                    </span>
                  </div>
                  <div class="chat-header-subtitle d-flex align-items-center gap-2">
                    <template v-if="active_is_group">
                      <span class="text-truncate">
                        {{ active_conversation_members.length }} member{{ active_conversation_members.length === 1 ? '' : 's' }}
                      </span>
                    </template>
                    <template v-else>
                      <span class="text-truncate">{{ active_conversation_bio || 'Team member' }}</span>
                    </template>
                  </div>
                </div>
                <div class="d-flex gap-1 ms-auto">
                  <button
                    class="oc-icon-btn"
                    :class="{ accent: show_info_panel }"
                    title="Conversation info"
                    @click="toggle_info_panel"
                  >
                    <i :class="show_info_panel ? 'fas fa-times' : 'fas fa-info-circle'"></i>
                  </button>
                  <button
                    class="oc-icon-btn"
                    :class="{ accent: show_message_search }"
                    title="Search messages"
                    @click="toggle_message_search"
                  >
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>

              <transition name="oc-search-slide">
                <div
                  v-if="show_message_search"
                  class="msg-search-bar d-flex align-items-center flex-shrink-0 gap-2 px-2 px-md-3 py-2 border-bottom"
                >
                  <div class="d-flex align-items-center flex-grow-1 gap-2 rounded-pill px-3 py-1 msg-search-input-wrap">
                    <i class="fas fa-search text-muted flex-shrink-0 msg-search-icon"></i>
                    <input
                      ref="msg_search_input"
                      type="text"
                      class="flex-grow-1 border-0 bg-transparent msg-search-input"
                      placeholder="Find in chat…"
                      v-model="message_search_query"
                      @input="on_search_input"
                      @keydown.enter.exact.prevent="next_search_result"
                      @keydown.shift.enter.prevent="prev_search_result"
                      @keydown.esc="clear_message_search"
                    />
                    <span
                      v-if="message_search_query || search_filter_person || search_filter_date"
                      class="text-muted flex-shrink-0 d-none d-sm-inline msg-search-count"
                    >
                      <template v-if="message_search_matches.length">
                        {{ message_search_index + 1 }}&nbsp;/&nbsp;{{ message_search_matches.length }}
                      </template>
                      <template v-else>No results</template>
                    </span>
                  </div>

                  <span
                    v-if="message_search_query && message_search_matches.length"
                    class="badge rounded-pill bg-secondary d-inline d-sm-none flex-shrink-0 msg-search-badge"
                  >{{ message_search_index + 1 }}/{{ message_search_matches.length }}</span>

                  <button
                    class="btn btn-sm btn-light rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 p-0 msg-search-nav-btn"
                    title="Previous (Shift+Enter)"
                    :disabled="message_search_matches.length < 2"
                    @click="prev_search_result"
                  ><i class="fas fa-chevron-up msg-search-nav-icon"></i></button>

                  <button
                    class="btn btn-sm btn-light rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 p-0 msg-search-nav-btn"
                    title="Next (Enter)"
                    :disabled="message_search_matches.length < 2"
                    @click="next_search_result"
                  ><i class="fas fa-chevron-down msg-search-nav-icon"></i></button>

                  <button
                    class="msg-search-nav-btn btn btn-sm rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 p-0 msg-filter-toggle-btn"
                    :class="{ 'filter-panel-active': show_find_panel }"
                    title="Filter results"
                    @click="toggle_find_panel"
                  >
                    <i class="fas fa-sliders-h msg-search-nav-icon"></i>
                    <span v-if="!show_find_panel && (search_filter_person || search_filter_date)" class="filter-active-dot"></span>
                  </button>

                  <button
                    class="btn btn-sm btn-light rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 p-0 msg-search-nav-btn"
                    title="Close (Esc)"
                    @click="clear_message_search"
                  ><i class="fas fa-times msg-search-nav-icon"></i></button>
                </div>
              </transition>

              <div v-if="pinned_messages.length && !show_info_panel && !show_message_search" class="pinned-bar" @click="open_info_panel('pinned')">
                <div class="pinned-bar-strip d-flex align-items-center gap-2">
                  <div class="pinned-bar-line flex-shrink-0"></div>
                  <div class="pinned-bar-content flex-grow-1 text-start">
                    <span class="pinned-bar-label fw-bold d-block text-uppercase">
                      {{ pinned_messages.length }} pinned {{ pinned_messages.length === 1 ? 'message' : 'messages' }}
                    </span>
                    <span class="pinned-bar-preview d-block text-truncate">
                      {{ pinned_messages[pinned_messages.length - 1]?.content
                         || (pinned_messages[pinned_messages.length - 1]?.attachments?.length ? '📎 Attachment' : '—') }}
                    </span>
                  </div>
                  <i class="fas fa-chevron-right pinned-bar-chevron flex-shrink-0"></i>
                </div>
              </div>

              <div class="chat-main-region position-relative flex-grow-1 d-flex overflow-hidden">

                <div ref="scroll_area" class="messages-area flex-grow-1">

                  <div v-if="messages_loading && !messages.length" class="oc-loading d-flex flex-column align-items-center justify-content-center">
                    <div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>
                    <p>Loading messages…</p>
                  </div>

                  <div v-else>

                    <!-- Load more indicator — tiny, sits at the very top of the message list -->
                    <div class="text-center py-1 load-more-container">
                      <div
                        v-if="loading_more_messages"
                        class="d-flex align-items-center justify-content-center gap-2 py-1 load-more-loading"
                      >
                        <span class="spinner-border spinner-border-sm load-more-spinner"></span>
                        <span>Loading older messages…</span>
                      </div>
                      <button
                        v-else-if="messages_has_more"
                        class="btn btn-sm btn-outline-secondary rounded-pill px-3"
                        style="font-size:0.74rem;"
                        @click="load_more_messages"
                      >
                        <i class="fas fa-arrow-up me-1"></i>Load older messages
                      </button>
                    </div>

                    <div v-for="(item, i) in rendered_stream" :key="item._k ?? i">

                      <div v-if="item.kind === 'stamp'" class="date-stamp"><span>{{ item.when }}</span></div>
                      <div v-else-if="item.kind === 'unread'" class="unread-divider"><span>Unread Messages</span></div>

                      <div
                        v-else-if="item.kind === 'msg'"
                        class="message-row d-flex align-items-end"
                        :class="[
                          item.side === 'right' ? 'message-sent justify-content-end' : 'message-received justify-content-start',
                          {
                            'message-grouped': item.grouped_with_previous,
                            'message-group-start': item.show_sender,
                            'message-group-end': !item.grouped_with_next
                          }
                        ]"
                        @touchstart.passive="handle_touch_start(item, $event)"
                        @touchend.passive="handle_touch_end"
                        @touchmove.passive="handle_touch_move"
                      >

                        <div
                          v-if="item.side === 'left' && item.show_avatar"
                          class="oc-avatar oc-avatar-sm flex-shrink-0 me-2 mb-1 align-self-end"
                          :class="get_avatar_class(get_sender_name_by_id(item.id))"
                        >{{ get_initials(get_sender_name_by_id(item.id)) }}</div>
                        <div v-else-if="item.side === 'left'" class="message-avatar-spacer flex-shrink-0 me-2"></div>

                        <div
                          class="message-inner d-flex flex-column"
                          @mouseenter="hovered_message_key = item._k"
                          @mouseleave="hovered_message_key = null"
                        >

                          <div
                            v-show="hovered_message_key === item._k || active_toolbar_key === item._k"
                            class="msg-hover-toolbar d-flex align-items-center mb-1"
                            :class="item.side === 'right' ? 'align-self-end' : 'align-self-start'"
                            @click.stop
                          >
                            <div class="msg-tb-pill d-flex align-items-center gap-1 px-2 py-1">

                              <button
                                v-for="e in quick_emojis" :key="e"
                                class="emoji-btn-tb"
                                :class="{ 'emoji-btn-active': my_reaction_for(item) === e }"
                                :title="e"
                                @click.stop="send_reaction(item, e, $event)"
                              >{{ e }}</button>

                              <div class="position-relative">
                                <button
                                  class="msg-tb-btn msg-tb-btn-emoji"
                                  title="More reactions"
                                  @click.stop="toggle_emoji_picker(item, $event)"
                                >
                                  <i class="far fa-smile"></i>
                                </button>
                                <div
                                  v-if="emoji_picker_key === item._k"
                                  class="emoji-picker-popup position-absolute"
                                  :class="item.side === 'left' ? 'emoji-picker-left' : 'emoji-picker-right'"
                                  @click.stop
                                >
                                  <EmojiPicker
                                    :native="true"
                                    :hide-search="false"
                                    :hide-group-names="false"
                                    :disable-sticky-group-names="false"
                                    theme="light"
                                    @select="(emoji) => { send_reaction(item, emoji.i, null); emoji_picker_key = null; }"
                                  />
                                </div>
                              </div>

                              <div class="msg-tb-divider mx-1"></div>

                              <button
                                v-if="item.side === 'left'"
                                class="msg-tb-btn"
                                title="Reply"
                                @click.stop="set_reply_to(item); active_toolbar_key = null"
                              >
                                <i class="fas fa-reply"></i>
                              </button>

                              <button
                                v-if="item.side === 'right'"
                                class="msg-tb-btn"
                                title="Edit"
                                @click.stop="start_edit(item); active_toolbar_key = null"
                              >
                                <i class="fas fa-pencil-alt"></i>
                              </button>

                              <div class="position-relative">
                                <button
                                  class="msg-tb-btn msg-tb-btn-dots"
                                  title="More actions"
                                  @click.stop="toggle_more_menu(item, $event)"
                                >
                                  <i class="fas fa-ellipsis-h"></i>
                                </button>

                                <div
                                  v-if="active_toolbar_key === item._k"
                                  class="msg-more-menu position-absolute"
                                  :class="[
                                    item.side === 'left' ? 'msg-more-menu-left' : 'msg-more-menu-right',
                                    toolbar_menu_direction[item._k] === 'down' ? 'msg-more-menu-down' : 'msg-more-menu-up'
                                  ]"
                                  @click.stop
                                >
                                  <button
                                    v-if="item.side === 'right'"
                                    class="msg-more-item d-flex align-items-center gap-2 w-100"
                                    @click.stop="set_reply_to(item); active_toolbar_key = null"
                                  >
                                    <i class="fas fa-reply fa-fw"></i>
                                    <span>Reply</span>
                                  </button>

                                  <button
                                    class="msg-more-item d-flex align-items-center gap-2 w-100"
                                    @click.stop="toggle_pin(item); active_toolbar_key = null"
                                  >
                                    <i class="fas fa-thumbtack fa-fw"></i>
                                    <span>{{ item.is_pinned ? 'Unpin message' : 'Pin message' }}</span>
                                  </button>

                                  <div class="msg-more-divider"></div>
                                  <button
                                    v-if="active_is_group && item.side === 'right' && item.read_count"
                                    class="msg-more-item d-flex align-items-center gap-2 w-100"
                                    @click.stop="open_read_receipts(item); active_toolbar_key = null"
                                  >
                                    <i class="fas fa-eye fa-fw"></i>
                                    <span>Seen by {{ item.read_count }}</span>
                                  </button>
                                  <button
                                    class="msg-more-item danger d-flex align-items-center gap-2 w-100"
                                    @click.stop="confirm_delete(item, 'me'); active_toolbar_key = null"
                                  >
                                    <i class="fas fa-trash fa-fw"></i>
                                    <span>Delete for me</span>
                                  </button>
                                  <template v-if="item.side === 'right'">
                                    <button
                                      class="msg-more-item danger d-flex align-items-center gap-2 w-100"
                                      @click.stop="confirm_delete(item, 'everyone'); active_toolbar_key = null"
                                    >
                                      <i class="fas fa-trash-alt fa-fw"></i>
                                      <span>Delete for everyone</span>
                                    </button>
                                  </template>
                                </div>
                              </div>

                            </div>
                          </div>

                          <div
                            class="message-bubble"
                            :class="[
                              item.edited_at ? 'message-updated-flash' : '',
                              item.side === 'right' ? 'align-self-end' : 'align-self-start'
                            ]"
                            :key="item.id + '-' + item.edited_at"
                            @click="handle_bubble_click(item)"
                          >

                            <div
                              v-if="item.side === 'left' && item.show_sender_name"
                              class="message-sender-name"
                            >
                              {{ item.sender_name }}
                            </div>

                            <div
                              v-if="item.reply_to"
                              class="reply-preview"
                              :class="item.side === 'right' ? 'reply-preview-sent' : 'reply-preview-received'"
                            >
                              <span class="reply-preview-sender">
                                {{ item.reply_to.sender ? `${item.reply_to.sender.first_name || ''} ${item.reply_to.sender.last_name || ''}`.trim() || item.reply_to.sender.username : 'Unknown' }}
                              </span>
                              <span class="reply-preview-text d-block text-truncate">
                                <template v-if="item.reply_to.content">{{ truncate_text(item.reply_to.content, 60) }}</template>
                                <template v-else-if="item.reply_to.attachments && item.reply_to.attachments.length">📎 Attachment</template>
                                <template v-else>—</template>
                              </span>
                            </div>

                            <div v-if="item.attachments && item.attachments.length" class="d-flex flex-column gap-2 mb-1">
                              <div v-for="file in item.attachments" :key="file.id || file.local_id || get_chat_file_name(file)">

                                <div v-if="is_image_file(get_chat_file_name(file))" class="chat-img-wrapper position-relative d-inline-block" @click.stop="!file.pending && preview_chat_file(file)" role="button">
                                  <!-- scroll_to_bottom() with no arg = guarded, only scrolls if already at bottom -->
                                  <img :src="get_chat_file_url(file)" :alt="get_chat_file_name(file)" class="chat-inline-img" loading="lazy" @load="scroll_to_bottom()" />
                                  <div class="chat-img-overlay position-absolute d-flex align-items-center justify-content-center">
                                    <span v-if="file.pending" class="spinner-border spinner-border-sm"></span>
                                    <i v-else class="fas fa-expand-alt"></i>
                                  </div>
                                </div>

                                <div v-else-if="is_video_file(get_chat_file_name(file)) && !file.pending">
                                  <video :src="get_chat_file_url(file)" class="chat-inline-video" controls preload="metadata" playsinline @play="stop_other_media($event)"></video>
                                </div>

                                <div v-else-if="is_audio_file(get_chat_file_name(file)) && !file.pending" class="chat-audio-wrapper">
                                  <div class="chat-audio-header d-flex align-items-center gap-2 mb-2">
                                    <div class="chat-audio-icon"><i class="fas fa-music"></i></div>
                                    <span class="chat-audio-name text-truncate">{{ get_chat_file_name(file) }}</span>
                                  </div>
                                  <audio :src="get_chat_file_url(file)" class="chat-inline-audio w-100" controls preload="metadata" @play="stop_other_media($event)"></audio>
                                </div>

                                <div v-else class="attach-card" @click.stop="!file.pending && preview_chat_file(file)" role="button">
                                  <div class="attach-icon"><i :class="file_icon_chat(get_chat_file_name(file))"></i></div>
                                  <div class="flex-grow-1 overflow-hidden">
                                    <div class="attach-name fw-semibold text-truncate">{{ get_chat_file_name(file) }}</div>
                                    <div class="attach-hint">
                                      <template v-if="file.pending"><span class="spinner-border spinner-border-sm me-1"></span>Saving...</template>
                                      <template v-else-if="item.failed">Not sent</template>
                                      <template v-else>Tap to preview</template>
                                    </div>
                                  </div>
                                  <a v-if="!file.pending" :href="get_chat_file_url(file)" :download="get_chat_file_name(file)" class="attach-dl-btn" title="Download" @click.stop>
                                    <i class="fas fa-download"></i>
                                  </a>
                                </div>

                              </div>
                            </div>

                            <div v-if="editing_message_key === item._k" class="edit-area w-100" @click.stop>
                              <textarea
                                v-model="edit_draft"
                                class="w-100"
                                rows="3"
                                @keydown.enter.exact.prevent="submit_edit(item)"
                                @keydown.esc="cancel_edit"
                              ></textarea>
                              <div class="d-flex align-items-center justify-content-end gap-2 mt-1">
                                <span class="edit-hint d-none d-md-block">Enter to save · Esc to cancel</span>
                                <button class="edit-icon-btn edit-icon-cancel" title="Cancel (Esc)" @click="cancel_edit">
                                  <i class="fas fa-times"></i>
                                </button>
                                <button class="edit-icon-btn edit-icon-save" title="Save (Enter)" :disabled="!edit_draft.trim() || saving_edit" @click="submit_edit(item)">
                                  <i v-if="saving_edit" class="fas fa-spinner fa-spin"></i>
                                  <i v-else class="fas fa-check"></i>
                                </button>
                              </div>
                            </div>

                            <p
                              v-else-if="item.text"
                              class="bubble-text mb-0"
                              :class="{ 'msg-search-active-bubble': message_search_matches[message_search_index] === item._k }"
                              v-html="highlight_text(item.text)"
                            ></p>

                            <div class="bubble-meta d-flex align-items-center justify-content-end gap-1 mt-1">
                              <span v-if="item.pending" class="bubble-edited">saving...</span>
                              <span v-else-if="item.failed" class="bubble-edited">not sent</span>
                              <span v-if="item.edited_at" class="bubble-edited">edited</span>
                              <span class="bubble-time">{{ item.timestamp }}</span>
                              <button
                                v-if="item.side === 'right' && !item.pending && !item.failed"
                                type="button"
                                class="seen-chip"
                                :class="{ seen: item.read_count > 0 }"
                                :title="active_is_group && item.read_count ? `Seen by ${item.read_count}` : (item.read_count ? 'Seen' : 'Delivered')"
                                @click.stop="open_read_receipts(item)"
                              >
                                <i :class="item.read_count > 0 ? 'fas fa-check-double tick-icon' : 'fas fa-check tick-icon'"></i>
                                <span v-if="active_is_group && item.read_count">{{ item.read_count }}</span>
                              </button>
                              <i v-if="item.is_pinned" class="fas fa-thumbtack pin-indicator"></i>
                            </div>

                            <div v-if="item.reactions && item.reactions.length" class="reactions-row d-flex flex-wrap gap-1 mt-1">
                              <button
                                v-for="rg in item.reactions" :key="rg.emoji"
                                class="reaction-chip"
                                :class="{ 'reaction-chip-mine': rg.reacted_by_me }"
                                :title="`${rg.count} reaction${rg.count > 1 ? 's' : ''}`"
                                @click.stop="send_reaction(item, rg.emoji, $event)"
                              >
                                <span class="reaction-emoji">{{ rg.emoji }}</span>
                                <span class="reaction-count">{{ rg.count }}</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chat-info-panel d-flex flex-column overflow-hidden" :class="{ open: show_info_panel }">
                  <div class="chat-info-header flex-shrink-0 bg-white border-bottom">
                    <div class="px-3 py-2">
                      <div class="nav nav-pills info-tabs gap-1 flex-nowrap">
                        <button v-if="!active_is_group" type="button" class="nav-link info-tab-btn" :class="{ active: info_tab === 'profile' }" @click="info_tab = 'profile'">Profile</button>
                        <button v-if="active_is_group" type="button" class="nav-link info-tab-btn" :class="{ active: info_tab === 'about' }" @click="info_tab = 'about'">About</button>
                        <button v-if="active_is_group" type="button" class="nav-link info-tab-btn" :class="{ active: info_tab === 'members' }" @click="info_tab = 'members'">Members</button>
                        <button type="button" class="nav-link info-tab-btn" :class="{ active: info_tab === 'shared' }" @click="info_tab = 'shared'">Shared</button>
                        <button type="button" class="nav-link info-tab-btn" :class="{ active: info_tab === 'pinned' }" @click="info_tab = 'pinned'">
                          Pinned
                          <span v-if="pinned_messages.length" class="badge rounded-pill bg-danger ms-1">{{ pinned_messages.length }}</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div v-if="info_tab === 'profile' && !active_is_group" class="chat-info-body flex-grow-1 overflow-y-auto p-3">
                    <div class="bg-white border rounded-3 p-3">
                      <div class="d-flex align-items-start gap-3">
                        <div class="oc-avatar oc-avatar-md flex-shrink-0 presence-wrap" :class="get_avatar_class(direct_chat_user?.name)">
                          <img v-if="direct_chat_user?.avatar" :src="direct_chat_user.avatar" :alt="direct_chat_user.name">
                          <span v-else>{{ direct_chat_user?.initials || get_initials(get_conversation_name(active_conversation)) }}</span>
                          <span class="presence-dot" :class="get_presence_class(direct_chat_user)"></span>
                        </div>
                        <div class="flex-grow-1 overflow-hidden">
                          <div class="fw-semibold text-truncate">{{ direct_chat_user?.name || get_conversation_name(active_conversation) }}</div>
                          <div v-if="direct_chat_user?.email" class="small text-muted text-truncate">{{ direct_chat_user.email }}</div>
                          <div class="small text-muted text-capitalize text-truncate">{{ get_presence_value(direct_chat_user) || 'status unavailable' }}</div>
                          <div v-if="direct_chat_user?.role || direct_chat_user?.department" class="small text-muted text-truncate">
                            {{ [direct_chat_user.role, direct_chat_user.department].filter(Boolean).join(' - ') }}
                          </div>
                          <p v-if="direct_chat_user?.bio" class="small text-muted mb-0 mt-2">{{ direct_chat_user.bio }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="row g-2 mt-2">
                      <div class="col-4"><div class="bg-white border rounded-3 p-2 text-center"><div class="fw-bold">{{ shared_document_files.length }}</div><div class="small text-muted">Files</div></div></div>
                      <div class="col-4"><div class="bg-white border rounded-3 p-2 text-center"><div class="fw-bold">{{ shared_links.length }}</div><div class="small text-muted">Links</div></div></div>
                      <div class="col-4"><div class="bg-white border rounded-3 p-2 text-center"><div class="fw-bold">{{ pinned_messages.length }}</div><div class="small text-muted">Pinned</div></div></div>
                    </div>
                  </div>

                  <div v-else-if="info_tab === 'about' && active_is_group" class="chat-info-body flex-grow-1 overflow-y-auto p-3">
                    <div class="bg-white border rounded-3 p-3">
                      <div class="small fw-semibold text-uppercase text-muted mb-2">About</div>
                      <p v-if="active_conversation_bio" class="mb-0 text-muted">{{ active_conversation_bio }}</p>
                      <p v-else class="mb-0 text-muted">No group description available yet.</p>
                    </div>
                    <div class="bg-white border rounded-3 p-3 mt-2">
                      <div class="d-flex justify-content-between small py-1"><span class="text-muted">Members</span><span class="fw-semibold">{{ active_conversation_members.length }}</span></div>
                      <div v-if="active_conversation?.created_at" class="d-flex justify-content-between small py-1"><span class="text-muted">Created</span><span class="fw-semibold">{{ format_date(active_conversation.created_at) }}</span></div>
                      <div v-if="get_conversation_creator_name(active_conversation)" class="d-flex justify-content-between small py-1 gap-3"><span class="text-muted">Created by</span><span class="fw-semibold text-truncate">{{ get_conversation_creator_name(active_conversation) }}</span></div>
                    </div>
                  </div>

                  <div v-else-if="info_tab === 'members' && active_is_group" class="chat-info-body flex-grow-1 overflow-y-auto p-3">
                    <div v-if="active_group_can_manage" class="group-manage-card mb-3">
                      <div class="group-manage-head d-flex align-items-start justify-content-between gap-3">
                        <div class="group-manage-copy"><strong>Manage group members</strong><span>Add people to this conversation or remove existing members.</span></div>
                        <span class="group-count-pill">{{ active_conversation_members.length }} active</span>
                      </div>
                      <div class="group-add-row position-relative">
                        <div class="group-member-search d-flex align-items-center gap-2" :class="{ open: group_member_add_open }" @click="group_member_add_open = true">
                          <i class="fas fa-user-plus"></i>
                          <input v-model.trim="group_member_search_query" type="text" placeholder="Add member" :disabled="group_members_updating || !available_group_users.length" @focus="group_member_add_open = true">
                          <button v-if="group_member_add_open" type="button" class="group-add-close" @click.stop="group_member_add_open = false; group_member_search_query = ''"><i class="fas fa-times"></i></button>
                          <i v-else class="fas fa-chevron-down group-add-chevron"></i>
                        </div>
                        <div v-if="group_member_add_open && available_group_users.length" class="group-add-results">
                          <button v-for="user in filtered_available_group_users.slice(0, 8)" :key="user.id" type="button" class="group-add-result d-flex align-items-center gap-2" :disabled="group_members_updating" @click="add_group_member(user.id)">
                            <span class="oc-avatar oc-avatar-xs flex-shrink-0" :class="get_avatar_class(`${user.first_name || ''} ${user.last_name || ''}`)">{{ get_initials(`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email || user.username) }}</span>
                            <span class="group-add-result-copy flex-grow-1 text-start overflow-hidden"><strong class="d-block text-truncate">{{ `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email || user.username }}</strong><small class="d-block text-truncate">{{ user.email || user.username }}</small></span>
                            <i v-if="group_members_updating" class="fas fa-spinner fa-spin"></i><i v-else class="fas fa-user-plus"></i>
                          </button>
                          <div v-if="!filtered_available_group_users.length" class="group-add-empty">No users match your search.</div>
                        </div>
                        <div v-else-if="group_member_add_open" class="group-add-empty">Everyone available is already here.</div>
                      </div>
                    </div>
                    <div class="member-list-tools d-flex align-items-center gap-2 mb-2">
                      <div class="member-list-search d-flex align-items-center gap-2 flex-grow-1"><i class="fas fa-search"></i><input v-model.trim="group_member_list_query" type="text" placeholder="Search members"></div>
                      <span class="member-list-count">{{ filtered_active_conversation_members.length }} shown</span>
                    </div>
                    <div v-if="!active_conversation_members.length" class="info-empty-small">No member details available yet.</div>
                    <div v-else-if="!filtered_active_conversation_members.length" class="info-empty-small">No members match your search.</div>
                    <div v-else class="info-member-list">
                      <div v-for="member in filtered_active_conversation_members" :key="member.id || member.email || member.name" class="info-member-card d-flex align-items-start gap-2">
                        <div class="oc-avatar oc-avatar-md flex-shrink-0 presence-wrap" :class="get_avatar_class(member.name)">{{ member.initials }}<span class="presence-dot" :class="get_presence_class(member)"></span></div>
                        <div class="info-member-main flex-grow-1 overflow-hidden">
                          <div class="d-flex align-items-center gap-2 min-w-0"><span class="info-member-name fw-semibold text-truncate">{{ member.name }}</span><span v-if="member.is_me" class="info-member-me flex-shrink-0">You</span><span v-if="String(member.conversation_role).toUpperCase() === 'ADMIN'" class="info-member-me flex-shrink-0">Admin</span></div>
                          <div v-if="member.role || member.department" class="info-member-role text-truncate">{{ [member.role, member.department].filter(Boolean).join(' - ') }}</div>
                          <div v-if="member.email" class="info-member-email text-truncate">{{ member.email }}</div>
                        </div>
                        <button v-if="active_group_can_manage && !member.is_me" class="member-remove-btn flex-shrink-0 align-self-center" title="Remove member" :disabled="group_members_updating" @click="confirm_remove_group_member(member)"><i class="fas fa-user-minus"></i><span>Remove</span></button>
                      </div>
                    </div>
                  </div>

                  <div v-else-if="info_tab === 'shared'" class="chat-info-body flex-grow-1 overflow-y-auto p-3">
                    <div class="d-flex align-items-center gap-2 bg-white border rounded-3 px-3 py-2 mb-2"><i class="fas fa-search text-muted small"></i><input v-model.trim="shared_search_query" type="search" class="form-control form-control-sm border-0 shadow-none p-0" placeholder="Search files, links, images..."></div>
                    <div class="d-flex flex-wrap gap-2 mb-3">
                      <button v-for="filter in ['all', 'files', 'images', 'links']" :key="filter" type="button" class="btn btn-sm rounded-pill shared-filter-pill" :class="shared_filter === filter ? 'btn-danger' : 'btn-light border'" @click="shared_filter = filter"><span class="text-capitalize">{{ filter }}</span><span class="badge rounded-pill ms-1" :class="shared_filter === filter ? 'bg-white text-danger' : 'bg-secondary bg-opacity-10 text-secondary'">{{ shared_content_counts[filter] }}</span></button>
                    </div>
                    <div v-if="!has_filtered_shared_content" class="info-empty-state d-flex flex-column align-items-center text-center bg-white border rounded-3"><i class="fas fa-folder-open"></i><p>No shared content found.</p></div>
                    <template v-else>
                      <section v-if="filtered_shared_files.length" class="mb-3">
                        <div class="d-flex align-items-center justify-content-between mb-2"><h3 class="small fw-bold text-uppercase text-muted mb-0">Recent files</h3><button type="button" class="btn btn-sm btn-link text-dark text-decoration-none p-0" @click="shared_filter = 'files'">View all</button></div>
                        <div v-for="file in filtered_shared_files.slice(0, shared_filter === 'files' ? filtered_shared_files.length : 4)" :key="file.id || file.message_key" class="shared-item w-100 d-flex align-items-center gap-2 text-start bg-white border rounded-3 p-2 mb-2">
                          <span class="shared-icon d-inline-flex align-items-center justify-content-center rounded-3 flex-shrink-0"><i :class="file_icon_chat(get_chat_file_name(file))"></i></span>
                          <span class="flex-grow-1 overflow-hidden"><span class="fw-semibold small d-block text-truncate">{{ get_chat_file_name(file) }}</span><span class="shared-meta small text-muted d-block text-truncate">{{ get_shared_meta(file) }}</span></span>
                          <span class="shared-actions d-flex align-items-center gap-1 flex-shrink-0">
                            <button type="button" class="shared-action-btn btn btn-sm btn-light rounded-circle" title="Preview" @click="preview_chat_file(file)"><i class="fas fa-eye"></i></button>
                            <button type="button" class="shared-action-btn btn btn-sm btn-light rounded-circle" title="Go to message" @click="jump_to_message(file.message_id)"><i class="fas fa-comment-dots"></i></button>
                          </span>
                        </div>
                      </section>
                      <section v-if="filtered_shared_images.length" class="mb-3">
                        <div class="d-flex align-items-center justify-content-between mb-2"><h3 class="small fw-bold text-uppercase text-muted mb-0">Images</h3><button type="button" class="btn btn-sm btn-link text-dark text-decoration-none p-0" @click="shared_filter = 'images'">View all</button></div>
                        <div class="media-grid"><button v-for="image in filtered_shared_images.slice(0, shared_filter === 'images' ? filtered_shared_images.length : 6)" :key="image.id || image.message_key" type="button" class="media-thumb border-0 p-0 overflow-hidden position-relative" @click="preview_chat_file(image)"><img :src="get_chat_file_url(image)" :alt="get_chat_file_name(image)"><span class="media-thumb-overlay d-flex align-items-center justify-content-center"><i class="fas fa-eye"></i></span></button></div>
                      </section>
                      <section v-if="filtered_shared_links.length" class="mb-3">
                        <div class="d-flex align-items-center justify-content-between mb-2"><h3 class="small fw-bold text-uppercase text-muted mb-0">Links</h3><button type="button" class="btn btn-sm btn-link text-dark text-decoration-none p-0" @click="shared_filter = 'links'">View all</button></div>
                        <div v-for="link in filtered_shared_links.slice(0, shared_filter === 'links' ? filtered_shared_links.length : 4)" :key="link.id" class="shared-item d-flex align-items-center gap-2 bg-white border rounded-3 p-2 mb-2">
                          <span class="shared-icon d-inline-flex align-items-center justify-content-center rounded-3 flex-shrink-0"><i class="fas fa-link text-danger"></i></span>
                          <div class="flex-grow-1 overflow-hidden"><div class="fw-semibold small text-truncate">{{ link.title }}</div><div class="small text-muted text-truncate">{{ link.url }}</div><div class="shared-meta small text-muted text-truncate">{{ get_shared_meta(link) }}</div></div>
                          <div class="shared-actions d-flex align-items-center gap-1 flex-shrink-0">
                            <button type="button" class="shared-action-btn btn btn-sm btn-light rounded-circle" title="Copy link" @click="copy_link(link.url)"><i class="fas fa-copy"></i></button>
                            <button type="button" class="shared-action-btn btn btn-sm btn-light rounded-circle" title="Open link" @click="open_link(link.url)"><i class="fas fa-external-link-alt"></i></button>
                            <button type="button" class="shared-action-btn btn btn-sm btn-light rounded-circle" title="Go to message" @click="jump_to_message(link.message_id)"><i class="fas fa-comment-dots"></i></button>
                          </div>
                        </div>
                      </section>
                    </template>
                  </div>

                  <div v-else-if="info_tab === 'pinned'" class="chat-info-body flex-grow-1 overflow-y-auto p-3">
                    <div v-if="!pinned_messages.length" class="info-empty-state d-flex flex-column align-items-center text-center bg-white border rounded-3"><i class="fas fa-thumbtack"></i><p>No pinned messages yet.</p></div>
                    <div v-else><div v-for="msg in pinned_messages" :key="msg.id" class="shared-item d-flex align-items-start gap-3 bg-white border rounded-3 p-2 mb-2"><span class="shared-icon d-inline-flex align-items-center justify-content-center rounded-3 flex-shrink-0"><i class="fas fa-thumbtack text-danger"></i></span><div class="flex-grow-1 overflow-hidden"><div class="fw-semibold text-truncate">{{ get_sender_name(msg.sender) }}</div><div class="small text-muted">{{ msg.content || (msg.attachments?.length ? 'Attachment' : '') }}</div><div class="shared-meta small text-muted mt-1">{{ format_date(msg.created_at) }}</div></div><button class="btn btn-sm btn-light rounded-circle flex-shrink-0" title="Unpin" @click="toggle_pin_by_msg(msg)"><i class="fas fa-times"></i></button></div></div>
                  </div>
                </div>
                <div
                  class="find-in-chat-panel d-flex flex-column"
                  :class="{ open: show_find_panel && show_message_search && !show_info_panel }"
                >
                  <div class="fic-header d-flex align-items-center flex-shrink-0">
                    <span class="fic-title fw-bold">Find in chat</span>
                    <span v-if="message_search_matches.length" class="badge rounded-pill bg-secondary bg-opacity-10 text-secondary ms-2">
                      {{ message_search_matches.length }} result{{ message_search_matches.length !== 1 ? 's' : '' }}
                    </span>
                    <button class="oc-icon-btn ms-auto" @click="toggle_find_panel" title="Close panel">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>

                  <div class="fic-filters flex-shrink-0">
                    <div class="d-flex flex-column gap-1">
                      <label class="fic-filter-label fw-bold text-uppercase mb-0">From</label>
                      <div class="fic-filter-control d-flex align-items-center gap-1">
                        <i class="fas fa-user fic-filter-icon flex-shrink-0"></i>
                        <select v-model="search_filter_person" class="fic-select">
                          <option value="">Anyone</option>
                          <option
                            v-for="p in conversation_participants"
                            :key="p.id"
                            :value="p.id"
                          >{{ p.name }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="d-flex flex-column gap-1">
                      <label class="fic-filter-label fw-bold text-uppercase mb-0">Date</label>
                      <div class="fic-filter-control d-flex align-items-center gap-1">
                        <i class="fas fa-calendar-alt fic-filter-icon"></i>
                        <input
                          type="date"
                          v-model="search_filter_date"
                          class="fic-date-input"
                          :max="today_date"
                        />
                      </div>
                    </div>

                    <button
                      v-if="search_filter_person || search_filter_date"
                      class="fic-clear-btn btn btn-link btn-sm ps-0"
                      @click="search_filter_person = ''; search_filter_date = ''"
                    >
                      <i class="fas fa-times me-1"></i>Clear filters
                    </button>

                  </div>

                  <div class="fic-results flex-grow-1 overflow-y-auto">
                    <div
                      v-if="!message_search_query && !search_filter_person && !search_filter_date"
                      class="d-flex flex-column align-items-center justify-content-center text-center p-5"
                    >
                      <i class="as fa-search fa-2x text-muted opacity-50"></i>
                      <p class="fic-empty-text text-muted small lh-base mb-0 mt-2">Type to search messages<br><span>or apply a filter above</span></p>
                    </div>
                    <div
                      v-else-if="!message_search_matches.length"
                      class="d-flex flex-column align-items-center justify-content-center text-center p-5"
                    >
                      <i class="fas fa-comment-slash fic-empty-icon"></i>
                      <p class="fic-empty-text text-muted small lh-base mb-0 mt-2">No messages found</p>
                    </div>

                    <div v-else>
                      <button
                        v-for="(key, idx) in message_search_matches"
                        :key="key"
                        class="fic-result-card w-100 text-start d-flex flex-column border-0 bg-transparent"
                        :class="{ 'fic-result-active': message_search_index === idx }"
                        @click="jump_to_result(idx)"
                      >
                        <div class="fic-result-meta d-flex align-items-center gap-2 mb-1">
                          <div
                            class="oc-avatar oc-avatar-sm flex-shrink-0"
                            :class="get_avatar_class(get_result_sender_name(key))"
                          >{{ get_initials(get_result_sender_name(key)) }}</div>
                          <span class="fic-result-sender fw-semibold">{{ get_result_sender_name(key) }}</span>
                          <span class="fic-result-time ms-auto text-nowrap flex-shrink-0">{{ get_result_time(key) }}</span>
                        </div>
                        <p
                          class="fic-result-snippet mb-0"
                          v-html="highlight_text(get_result_text(key))"
                        ></p>
                        <span
                          v-if="!get_result_text(key) && get_result_has_attachment(key)"
                          class="fic-attach-badge badge bg-light text-secondary rounded-2 d-inline-flex align-items-center"
                        ><i class="fas fa-paperclip me-1"></i>Attachment</span>
                        <span class="fic-jump-label d-inline mt-1">
                          <i class="fas fa-arrow-right me-1"></i>Go to message
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div ref="scroll_anchor_el" class="chat-scroll-anchor"></div>

              <!-- Jump to latest / New messages banner — sits just above the input bar -->
              <div
                v-if="new_messages_banner || user_scrolled_up"
                class="oc-scroll-to-bottom-btn d-flex align-items-center justify-content-center"
              >
                <button
                  class="new-messages-banner d-flex align-items-center gap-2 text-nowrap"
                  @click="jump_to_bottom"
                >
                  <i class="fas fa-arrow-down"></i>
                  <span>{{ new_messages_banner ? 'New messages' : 'Jump to latest' }}</span>
                </button>
              </div>

              <div v-if="active_typing_text" class="oc-typing-indicator flex-shrink-0">
                {{ active_typing_text }}
              </div>

              <div v-if="selected_file" class="attach-preview-strip d-flex align-items-center flex-shrink-0">
                <div v-if="is_image_file(selected_file.name) && selected_file_preview_url" class="attach-preview-thumb flex-shrink-0">
                  <img :src="selected_file_preview_url" alt="preview" />
                </div>
                <div v-else class="attach-preview-icon d-flex align-items-center justify-content-center flex-shrink-0">
                  <i class="fas fa-paperclip"></i>
                </div>
                <span class="attach-preview-name flex-grow-1 text-truncate">{{ selected_file.name }}</span>
                <button class="attach-preview-rm d-flex align-items-center justify-content-center flex-shrink-0" @click="remove_selected_file">
                  <i class="fas fa-times"></i>
                </button>
              </div>

              <div v-if="reply_to_message" class="reply-to-strip d-flex align-items-center flex-shrink-0">
                <div class="reply-to-strip-line flex-shrink-0"></div>
                <div class="reply-to-strip-body flex-grow-1 overflow-hidden">
                  <span class="reply-to-strip-sender d-block fw-bold">{{ reply_to_message.sender_name }}</span>
                  <span class="reply-to-strip-text d-block text-truncate">
                    <template v-if="reply_to_message.content">{{ truncate_text(reply_to_message.content, 70) }}</template>
                    <template v-else-if="reply_to_message.attachments && reply_to_message.attachments.length">📎 Attachment</template>
                    <template v-else>—</template>
                  </span>
                </div>
                <button class="reply-to-strip-close flex-shrink-0" title="Cancel reply" @click="clear_reply_to">
                  <i class="fas fa-times"></i>
                </button>
              </div>

              <div class="message-input-bar d-flex align-items-end flex-shrink-0">
                <input type="file" ref="file_input" class="d-none" @change="handle_file_select">
                <button class="oc-input-btn" :class="{ 'has-file': selected_file }" title="Attach file" @click="$refs.file_input.click()">
                  <i class="fas fa-paperclip"></i>
                </button>
                <div class="oc-input-wrap d-flex align-items-end flex-grow-1">
                  <textarea
                    v-model.trim="draft"
                    class="oc-textarea"
                    placeholder="Send a message…"
                    rows="1"
                    :disabled="sending_message"
                    @keydown.enter.exact.prevent="send"
                    @input="auto_resize_textarea"
                  ></textarea>
                  <button class="oc-send-btn" :disabled="(!draft && !selected_file) || sending_message" @click="send" title="Send">
                    <i v-if="sending_message" class="fas fa-spinner fa-spin"></i>
                    <i v-else class="fas fa-paper-plane"></i>
                  </button>
                </div>
              </div>

            </template>
          </section>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile action sheet -->
  <Teleport to="body">
    <div
      v-if="mobile_action_item"
      class="mobile-action-sheet-overlay position-fixed d-flex align-items-end"
      @click.self="mobile_action_item = null"
    >
      <div class="mobile-action-sheet w-100">
        <div class="action-sheet-handle mx-auto"></div>

        <div class="action-sheet-preview">
          <div class="action-sheet-preview-text text-truncate">
            "{{ truncate_text(mobile_action_item.text || '📎 Attachment', 60) }}"
          </div>
        </div>

        <div class="action-sheet-emoji-row d-flex justify-content-center gap-2 px-4 py-2">
          <button
            v-for="e in quick_emojis" :key="e"
            class="emoji-btn"
            :class="{ 'emoji-btn-active': my_reaction_for(mobile_action_item) === e }"
            @click="send_reaction(mobile_action_item, e, null); mobile_action_item = null"
          >{{ e }}</button>
        </div>

        <button class="action-sheet-btn d-flex align-items-center gap-3 w-100 text-start"
          @click="set_reply_to(mobile_action_item); mobile_action_item = null">
          <i class="fas fa-reply"></i>Reply
        </button>
        <button class="action-sheet-btn d-flex align-items-center gap-3 w-100 text-start"
          @click="toggle_pin(mobile_action_item); mobile_action_item = null">
          <i class="fas fa-thumbtack"></i>
          {{ mobile_action_item.is_pinned ? 'Unpin message' : 'Pin message' }}
        </button>
        <button v-if="mobile_action_item.side === 'right'"
          class="action-sheet-btn d-flex align-items-center gap-3 w-100 text-start"
          @click="start_edit(mobile_action_item); mobile_action_item = null">
          <i class="fas fa-pencil-alt"></i>Edit message
        </button>
        <button v-if="mobile_action_item.side === 'right'"
          class="action-sheet-btn danger d-flex align-items-center gap-3 w-100 text-start"
          @click="confirm_delete(mobile_action_item, 'everyone'); mobile_action_item = null">
          <i class="fas fa-trash-alt"></i>Delete for everyone
        </button>
        <button
          class="action-sheet-btn danger d-flex align-items-center gap-3 w-100 text-start"
          @click="confirm_delete(mobile_action_item, 'me'); mobile_action_item = null">
          <i class="fas fa-trash"></i>Delete for me
        </button>
        <button class="action-sheet-btn d-flex align-items-center gap-3 w-100 text-start"
          @click="mobile_action_item = null">
          <i class="fas fa-times"></i>Cancel
        </button>
      </div>
    </div>
  </Teleport>

  <div class="modal fade" id="newConversationModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-new-conv">
      <div class="modal-content">
        <div class="modal-header oc-modal-header">
          <div>
            <h5 class="oc-modal-title fw-bold mb-0 gradient-text">{{ new_conversation_mode === 'group' ? 'Create group' : 'Start conversation' }}</h5>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body oc-modal-body">
          <div class="oc-compose-mode d-grid">
            <button
              type="button"
              class="oc-compose-mode-btn"
              :class="{ active: new_conversation_mode === 'direct' }"
              @click="new_conversation_mode = 'direct'"
            >
              <span class="oc-compose-icon"><i class="fas fa-user"></i></span>
              <span class="oc-compose-copy">
                <strong>Direct</strong>
                <small>Message one person</small>
              </span>
            </button>
            <button
              type="button"
              class="oc-compose-mode-btn"
              :class="{ active: new_conversation_mode === 'group' }"
              @click="new_conversation_mode = 'group'"
            >
              <span class="oc-compose-icon"><i class="fas fa-users"></i></span>
              <span class="oc-compose-copy">
                <strong>Group</strong>
                <small>Bring a team together</small>
              </span>
            </button>
          </div>

          <div v-if="new_conversation_mode === 'group'" class="oc-group-panel">
            <div class="oc-group-title-row d-flex align-items-center gap-2">
              <div class="oc-group-badge d-flex align-items-center justify-content-center">
                <i class="fas fa-layer-group"></i>
              </div>
              <div class="min-w-0">
                <label class="oc-group-label mb-0">Group name</label>
                <div class="oc-group-count">{{ new_group_user_ids.length }} member{{ new_group_user_ids.length !== 1 ? 's' : '' }} selected</div>
              </div>
            </div>
            <input
              type="text"
              class="oc-group-name-input"
              placeholder="e.g. Finance review"
              v-model="new_group_name"
              maxlength="80"
            >
            <div class="oc-selected-strip" :class="{ empty: selected_group_users.length === 0 }">
              <template v-if="selected_group_users.length">
                <button
                  v-for="user in selected_group_users"
                  :key="user.id"
                  type="button"
                  class="oc-selected-pill"
                  @click="toggle_group_user(user.id)"
                >
                  <span>{{ get_initials(`${user.first_name} ${user.last_name}`) }}</span>
                  {{ user.first_name }} {{ user.last_name }}
                  <i class="fas fa-times"></i>
                </button>
              </template>
              <span v-else>Select people below to build the group.</span>
            </div>
          </div>
          <div class="oc-modal-search" :class="{ 'group-search': new_conversation_mode === 'group' }">
            <div class="oc-contact-heading d-flex align-items-center justify-content-between">
              <span>{{ new_conversation_mode === 'group' ? 'Add members' : 'Choose a contact' }}</span>
              <small v-if="filtered_users.length">{{ filtered_users.length }} shown</small>
            </div>
            <div class="oc-modal-search-inner d-flex align-items-center gap-2">
              <i class="fas fa-search flex-shrink-0"></i>
              <input type="text" class="flex-grow-1" placeholder="Search by name or email" v-model="contact_search_query" :disabled="users_loading">
            </div>
          </div>
          <div v-if="users_loading" class="oc-loading d-flex flex-column align-items-center justify-content-center py-5">
            <div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>
            <p>Loading contacts…</p>
          </div>
          <div v-else-if="filtered_users.length === 0" class="sidebar-empty d-flex flex-column align-items-center justify-content-center text-center py-5">
            <i class="fas fa-users fa-3x"></i>
            <h6>{{ contact_search_query ? 'No contacts found' : 'No contacts available' }}</h6>
            <p v-if="contact_search_query">Try a different search term</p>
          </div>
          <div v-else class="oc-contact-list">
            <a
              v-for="user in filtered_users" :key="user.id"
              href="#" class="oc-contact-item d-flex align-items-center gap-3 text-decoration-none"
              :class="{ active: new_conversation_mode === 'group' ? is_group_user_selected(user.id) : new_conversation_user_id === user.id }"
              @click.prevent="select_modal_user(user)"
            >
              <div class="oc-avatar oc-avatar-md flex-shrink-0" :class="get_avatar_class(`${user.first_name} ${user.last_name}`)">
                {{ get_initials(`${user.first_name} ${user.last_name}`) }}
              </div>
              <div class="flex-grow-1 overflow-hidden">
                <div class="oc-contact-name fw-semibold">
                  {{ user.first_name }} {{ user.last_name }}
                  <span v-if="user.id === current_user_id" class="text-muted fw-normal">(Me)</span>
                </div>
                <div class="oc-contact-email text-truncate">{{ user.email }}</div>
              </div>
              <span
                class="oc-contact-select flex-shrink-0 d-flex align-items-center justify-content-center"
                :class="{ checked: new_conversation_mode === 'group' ? is_group_user_selected(user.id) : new_conversation_user_id === user.id }"
              >
                <i class="fas fa-check"></i>
              </span>
            </a>
          </div>
        </div>
        <div class="modal-footer oc-modal-footer">
          <div v-if="new_conversation_mode === 'group'" class="oc-footer-summary me-auto">
            {{ new_group_name.trim() || 'Untitled group' }} · {{ new_group_user_ids.length }} selected
          </div>
          <button type="button" class="btn-oc-ghost btn" data-bs-dismiss="modal">Cancel</button>
          <button v-if="new_conversation_mode === 'direct'" class="btn-oc-primary btn" :disabled="!new_conversation_user_id || starting_conversation" @click="start_new_conversation">
            <i v-if="starting_conversation" class="fas fa-spinner fa-spin me-2"></i>
            {{ starting_conversation ? 'Starting…' : 'Start Chat' }}
          </button>
          <button
            v-else
            class="btn-oc-primary btn"
            :disabled="!new_group_name.trim() || new_group_user_ids.length === 0 || starting_group"
            @click="start_new_group_conversation"
          >
            <i v-if="starting_group" class="fas fa-spinner fa-spin me-2"></i>
            {{ starting_group ? 'Creating...' : 'Create Group' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="conversationActionModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="oc-modal-title fw-bold mb-0">{{ conversation_action_title() }}</h6>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="oc-modal-delete-body p-3">
          <p class="small mb-0 oc-modal-delete-text">{{ conversation_action_body() }}</p>
        </div>
        <div class="d-flex gap-2 justify-content-end p-3 oc-modal-delete-footer">
          <button type="button" class="btn-oc-ghost btn" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn-oc-danger btn" :disabled="conversation_action_loading" @click="execute_conversation_action">
            <i v-if="conversation_action_loading" class="fas fa-spinner fa-spin me-1"></i>{{ conversation_action_button_label() }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="deleteMessageModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="oc-modal-title fw-bold mb-0">{{ delete_modal_title() }}</h6>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="oc-modal-delete-body p-3">
          <p class="small mb-0 oc-modal-delete-text">{{ delete_modal_text() }}</p>
        </div>
        <div class="d-flex gap-2 justify-content-end p-3 oc-modal-delete-footer">
          <button type="button" class="btn-oc-ghost btn" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn-oc-danger btn" :disabled="deleting_message" @click="execute_delete">
            <i v-if="deleting_message" class="fas fa-spinner fa-spin me-1"></i>{{ delete_modal_button_label() }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="removeGroupMemberModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="oc-modal-title fw-bold mb-0">Remove member?</h6>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="oc-modal-delete-body p-3">
          <p class="small mb-0 oc-modal-delete-text">
            Remove {{ pending_remove_member?.name || 'this member' }} from {{ get_conversation_name(active_conversation) }}?
          </p>
        </div>
        <div class="d-flex gap-2 justify-content-end p-3 oc-modal-delete-footer">
          <button type="button" class="btn-oc-ghost btn" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn-oc-danger btn" :disabled="group_members_updating" @click="remove_group_member">
            <i v-if="group_members_updating" class="fas fa-spinner fa-spin me-1"></i>Remove
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="readReceiptsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="oc-modal-title fw-bold mb-0">Seen by</h6>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="read-receipt-list p-3">
          <div
            v-for="reader in read_receipt_item?.read_by || []"
            :key="reader.id"
            class="read-receipt-row d-flex align-items-center gap-2"
          >
            <div class="oc-avatar oc-avatar-sm flex-shrink-0" :class="get_avatar_class(`${reader.first_name || ''} ${reader.last_name || ''}`)">
              {{ get_initials(`${reader.first_name || ''} ${reader.last_name || ''}`.trim() || reader.email || reader.username) }}
            </div>
            <div class="min-w-0 flex-grow-1">
              <div class="read-receipt-name text-truncate">{{ `${reader.first_name || ''} ${reader.last_name || ''}`.trim() || reader.email || reader.username }}</div>
              <div class="read-receipt-time text-truncate">{{ format_time(reader.read_at) }}</div>
            </div>
          </div>
          <div v-if="!(read_receipt_item?.read_by || []).length" class="info-empty-small">
            No one has seen this message yet.
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- File Preview -->
  <div v-if="preview_modal" @click.self="preview_modal = false">
    <FilePreviewComponent
      :presigned_url="preview_file_url"
      @close="close_the_file_preview"
      :file_name="preview_file_name"
      :shared_access_level="preview_file_access_level"
      @open-office-file="open_chat_office_file(selected_preview_file)"
    />
  </div>

</div>
